var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-disclosure-dropdown',{staticClass:"gl-w-full gl-align-top gl-leading-normal",attrs:{"toggle-text":_vm.__('Code'),"items":_vm.items,"placement":"bottom-end","toggle-class":"gl-w-full @sm/panel:gl-w-auto","data-testid":"mr-code-dropdown"}})
}
var staticRenderFns = []

export { render, staticRenderFns }